import { render, staticRenderFns } from "./PickUpParams.vue?vue&type=template&id=7a53d558&"
import script from "./PickUpParams.vue?vue&type=script&lang=js&"
export * from "./PickUpParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports